export default __webpack_public_path__ + "0c8604772867abdc1a7487428faa8473.png";